
import { Component, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../shared/api.service';
import { FormBuilder, FormGroup,Validators} from '@angular/forms';
import { NbToastrService} from '@nebular/theme';

@Component({
  selector: 'nb-reset-password',
  templateUrl: './reset-password.component.html',
})
export class resetPasswordComponent {
  validation_messages;
  alertflag = 0;
  messagealertflag=0;

  @Input() userPassword:string;
  @Input() userConfirmPassword:string;

  changePasswordForm: FormGroup;
  

  readonly passwordValidate = /^[A-Za-z0-9!@#$%^&*()_]{6,}$/;
  email: string;
  token: string;
  
    constructor(
        private router : Router,
        protected api : ApiService,
        private fb: FormBuilder,
        private route : ActivatedRoute,
        private toastrService: NbToastrService) {
      }
      ngOnInit() {
        this.email = this.route.snapshot.queryParamMap.get('email');
        // The reset link carries a single-use token; the account is taken from it.
        this.token = this.route.snapshot.queryParamMap.get('token');
        this.changePasswordForm = this.fb.group({

        passwordCtrl:['',[Validators.required, Validators.minLength(6),Validators.pattern(this.passwordValidate)]],
        repasswordCtrl:['',[Validators.required, Validators.pattern(this.passwordValidate)]],

        });

        if(!this.token){
          this.alertflag = 3;
          this.validation_messages = "This password reset link is invalid. Please request a new one.";
        }
      }

      onSubmit(duration,position){
        this.changePasswordForm.controls.passwordCtrl.markAsDirty();
        this.changePasswordForm.controls.repasswordCtrl.markAsDirty();

        var userPassword= this.changePasswordForm.controls.passwordCtrl.value;
        var userConfirmPassword= this.changePasswordForm.controls.repasswordCtrl.value;


        if(userPassword =='' || userConfirmPassword ==''){
          this.alertflag = 1;
          this.validation_messages =  "Your form is not filled please fill completely";

        }else if (!(userPassword == userConfirmPassword)){
              this.alertflag = 2;
              this.validation_messages =  "Password doesn't match!";
        }
        else{
            if(userPassword.length<6 || userConfirmPassword.length<6){
                this.alertflag = 4;
                this.validation_messages =  "Use 6 or more characters,numbers or symbols ";
            }else if(!this.token){
                this.alertflag = 3;
                this.validation_messages =  "This password reset link is invalid. Please request a new one.";
            }else{

                var resetPasswordvalue={
                    userPassword:this.changePasswordForm.controls.passwordCtrl.value,
                    userConfirmPassword:this.changePasswordForm.controls.repasswordCtrl.value,
                    email:this.email,
                    // The server identifies the account from this token, not from the email.
                    token:this.token
                }

                this.alertflag = 0;

                this.api.resetPasswordValues(resetPasswordvalue)
                .subscribe((data: any) => {
                    if(data['status'] == 200){
                      this.toastrService.show(
                        `Password Reset Successfully ! `,`Success`
                    );
                    this.messagealertflag = 1;
                    this.alertflag = 0;
                    this.router.navigate(['auth/login']);
                    }else{
                    // Anything other than 200 is a failure: show why instead of
                    // leaving the form looking like it worked.
                    this.messagealertflag = 0;
                    this.alertflag = 3;
                    this.validation_messages = data && data['message'] ? data['message']
                        : "Something went wrong while changing your Password";
                    }
                }, err => {
                    this.messagealertflag = 0;
                    this.alertflag = 3;
                    this.validation_messages = "Something went wrong while changing your Password";
                    console.error(err);
                });
            }
        }
    }

      close() {
        this.alertflag = 0;
      }

      onClose() {
        this.messagealertflag = 0;
      }
}